"use client";

import { ClientLogInForm } from "@/app/(guest)/login/LogIn/ClientLogIn";
import { ShowroomBuyerSelect } from "@/components/atoms/ShowroomBuyerSelect";
import useShowroom, {
  useLoginShowroomUser,
  useShowroomBuyer,
} from "@/lib/showroom/hooks/useShowroom";
import { ShowroomAccount } from "@/lib/showroom/types";
import { useSearchParams } from "next/navigation";
import { Suspense } from "react";
import styles from "./showroom.module.css";

const Showroom = () => {
  const { data, isLoading } = useShowroom();

  if (isLoading) return null;

  if (data?.user && data.buyers)
    return <ShowroomDashboard user={data.user} buyers={data.buyers} />;

  return <ShowroomLogin />;
};

export default Showroom;

const ShowroomLogin = () => {
  const { login } = useLoginShowroomUser();

  const { error } = login;

  return (
    <div data-layout="page">
      <section data-layout="content">
        <h1 className={styles.title}>Forhandler - Logg inn</h1>
        {error && <p className={styles.errorText}>{error.message}</p>}
        <Suspense>
          <ErrorMessage />
        </Suspense>
        <ClientLogInForm options={false} loginFunction={login} />
      </section>
    </div>
  );
};

const ShowroomDashboard = ({
  user,
  buyers,
}: {
  user: ShowroomAccount["user"];
  buyers: Array<{ email: string; id: string }>;
}) => {
  const { buyerId, setBuyerId } = useShowroomBuyer();

  return (
    <div data-layout="page" style={{ minHeight: "90vh" }}>
      <h1 className={styles.title}>Forhandler</h1>
      <p className={styles.email}>{user?.email}</p>

      <div className={styles.buyerSelector}>
        <label htmlFor="select-buyer">Velg kjøper</label>
        <ShowroomBuyerSelect
          buyers={buyers}
          value={buyerId}
          onBuyerChange={setBuyerId}
        />
      </div>
    </div>
  );
};

const ErrorMessage = () => {
  const searchParams = useSearchParams();
  const reason = searchParams.get("reason");
  const redirect = searchParams.get("redirect");

  if (reason === "expired") {
    return (
      <div>
        Din sesjon har utløpt. Vennligst logg inn på nytt.
        {redirect && (
          <p>Du vil bli videresendt tilbake til siden du prøvde å nå.</p>
        )}
      </div>
    );
  }

  return null;
};
